import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { SignoutCallbackComponent } from "redux-oidc";
import getUserManager from "../user-manager";
import { connect } from "react-redux";
import { Spinner } from "../../components//state-indicators";
import { Localized } from "../../components";
const SignoutCallback = () => {
    const userManager = getUserManager();

    const [redirectUrl, setURL] = useState(undefined);
    const [signedIn, signInToggle] = useState(true);
    const successCallback = user => {
        setURL(user?.state?.redirectUrl);
        signInToggle(false);
    };

    const errorCallback = error => {
        console.error(error);
    };

    return (
        <SignoutCallbackComponent userManager={userManager} successCallback={successCallback} errorCallback={errorCallback}>
            {signedIn ? (
                <div style={{ position: "relative", height: "100vh", width: "100vw" }}>
                    <Localized>
                        <Spinner withCaption fillParent={false} />
                    </Localized>
                </div>
            ) : redirectUrl !== undefined ? (
                <Navigate to={redirectUrl} />
            ) : (
                <Navigate to="/" />
            )}
        </SignoutCallbackComponent>
    );
};

export default connect()(SignoutCallback);
